/* tslint:disable */
/* eslint-disable */
/**
 * Account Settings API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { AccountDeletionWorkflowType } from './';
import {
    AccountDeletionWorkflowTypeFromJSON,
    AccountDeletionWorkflowTypeFromJSONTyped,
    AccountDeletionWorkflowTypeToJSON,
} from './';

/**
 * A request to schedule the deletion of an account or identity, for testing. Not available in production!
 * 
 * @export
 * @interface DeletionTaskSchedulingRequest
 */
export interface DeletionTaskSchedulingRequest {
    /**
     * 
     * @type {string}
     * @memberof DeletionTaskSchedulingRequest
     */
    accountId?: string;
    /**
     * 
     * @type {string}
     * @memberof DeletionTaskSchedulingRequest
     */
    identityId?: string;
    /**
     * 
     * @type {AccountDeletionWorkflowType}
     * @memberof DeletionTaskSchedulingRequest
     */
    workflowType: AccountDeletionWorkflowType;
}

/**
 * Check if a given object implements the DeletionTaskSchedulingRequest interface.
 */
export function instanceOfDeletionTaskSchedulingRequest(value: object): value is DeletionTaskSchedulingRequest {
    if (!('workflowType' in value) || value['workflowType'] === undefined) return false;
    return true;
}

export function DeletionTaskSchedulingRequestFromJSON(json: any): DeletionTaskSchedulingRequest {
    return DeletionTaskSchedulingRequestFromJSONTyped(json, false);
}

export function DeletionTaskSchedulingRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): DeletionTaskSchedulingRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'accountId': json['accountId'] == null ? undefined : json['accountId'],
        'identityId': json['identityId'] == null ? undefined : json['identityId'],
        'workflowType': AccountDeletionWorkflowTypeFromJSON(json['workflowType']),
    };
}

export function DeletionTaskSchedulingRequestToJSON(value?: DeletionTaskSchedulingRequest | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'accountId': value['accountId'],
        'identityId': value['identityId'],
        'workflowType': AccountDeletionWorkflowTypeToJSON(value['workflowType']),
    };
}

